export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_33169.6e5d1e4c.jpg";